import { render, staticRenderFns } from "./FileCardDe.vue?vue&type=template&id=54ab024e&"
import script from "./FileCardDe.vue?vue&type=script&lang=js&"
export * from "./FileCardDe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports